export const paymentReceiptDetailJson = {
  showSaveNextBtn: true,
  showAddButton: true,
  screenTitle: "Payment Receipt Details",
  formPathView: "/payment-details-view",

  tableColumnsToFilter: [
    {
      columnDisplayName: "Amount",
      columnKeyName: "amt",
      isChecked: true,
    },
    {
      columnDisplayName: "Date",
      columnKeyName: "date",
      isChecked: true,
    },
    {
      columnDisplayName: "Pay Type",
      columnKeyName: "payType",
      isChecked: true,
    },
    {
      columnDisplayName: "Stock Holder",
      columnKeyName: "toStakeHolderNameAndFirmName",
      isChecked: true,
    },
  ],
  searchList: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 4,
      lg: 4,
      sm: 4,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 4,
      lg: 4,
      sm: 4,
      xs: 12,
      dataKey: "toDate",
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },
  ],
};
